'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import AppInfo from './AppInfo';

class Maintenance extends Component {
    render() {
        return (
            <div className="app-wrapper maintenance-mode">
                <header role="banner">
                    <div className="app-header-container">
                        <div className="app-header d-flex bg-purple">
                            <a href="https://uw.edu" title="University of Washington Home">
                                <div className="uw-patch">University of Washington</div>
                                <div className="uw-wordmark">University of Washington</div>
                            </a>
                        </div>
                    </div>
                </header>
                <Container fluid className="bg-white">
                    <Row>
                        <Col className="p-5">
                            <main role="main" className="content pb-0" id="main-content">
                                <h1 className="h1 mb-4">SHHHH......</h1>
                                <h2 className="h3 text-uppercase mb-4">{this.props.title} is napping</h2>
                                <p>{this.props.title} is offline for some planned downtime to grow bigger & healthier. We will be back in a few hours.</p>
                                <div className="husky-dog" />
                            </main>
                        </Col>
                    </Row>
                </Container>
                <footer className="container-fluid p-3 fs-7 bg-navigate border border-3 border-start-0 border-end-0 border-bottom-0">
                    <div className="d-md-flex align-items-md-start justify-content-md-between">
                        <div className="text-center text-md-start">
                            <ul className="list-inline list-inline-pipe-separated">
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <a href="https://itconnect.uw.edu/it-connect-home/question/" target="_blank">UW-IT Help</a>
                                </li>
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <a href="https://itconnect.uw.edu/" target="_blank">IT Connect</a>
                                </li>
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <a href="https://www.washington.edu/online/privacy" target="_blank">Privacy</a>
                                </li>
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <a href="https://www.washington.edu/online/terms" target="_blank">Terms</a>
                                </li>
                            </ul>
                        </div>
                        <div className="text-center text-md-end mt-4 mt-md-0">
                            <ul className="list-inline list-inline-pipe-separated">
                                <li className="list-inline-item mb-2 mb-md-0">&copy; {new Date().getFullYear()} <a href="https://www.washington.edu/" target="_blank">University of Washington</a></li>
                                <li className="list-inline-item mb-2 mb-md-0">Seattle, WA</li>
                            </ul>
                            <ul className="list-unstyled d-flex flex-column flex-md-row gap-2 justify-content-end mb-0">
                                <li><AppInfo/></li>
                            </ul>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

Maintenance.propTypes = {
    title: PropTypes.string.isRequired
}

export default Maintenance;
